$(function () {

  if($(".vfr-lending-page-container").length === 0) return;
  $('.share-btn').click(function (e) {
    $('.share-dropdown').show();
    e.stopPropagation();
  });

  $('.mobile-share').click(function () {
    $('.share-modal').modal('show');
  });

  $(document).click(function () {
    $('.share-dropdown').hide();
  });

  $('.mobile-menu-content').click(function (e) {
    e.stopPropagation();
  });

});